var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "discount_svg__a",
    x1: "0%",
    x2: "100%",
    y1: "3.217%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1B9564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#39D546"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#discount_svg__a)",
    fillRule: "evenodd",
    d: "M12 6a2.179 2.179 0 00-1.136-1.93.126.126 0 01-.06-.145 2.21 2.21 0 00-2.73-2.73.123.123 0 01-.144-.06 2.21 2.21 0 00-3.86 0 .124.124 0 01-.145.06 2.209 2.209 0 00-2.729 2.73.124.124 0 01-.06.145 2.209 2.209 0 000 3.86.127.127 0 01.06.145 2.21 2.21 0 002.729 2.73.124.124 0 01.145.06 2.21 2.21 0 003.86 0 .123.123 0 01.144-.06 2.206 2.206 0 002.729-2.73.13.13 0 01.06-.145A2.172 2.172 0 0012 6zM7.847 8.77a.925.925 0 01-.654-1.577.925.925 0 011.577.654.923.923 0 01-.923.922zm-3.77-.127a.51.51 0 01-.72-.72l4.979-4.98a.512.512 0 11.72.721l-4.979 4.98zm.077-5.412a.924.924 0 110 1.848.924.924 0 010-1.848z"
  })));
}
export default SvgDiscount;